module Meevo.Components.Tracking {
    angular.module("meevo.components.tracking", []);
}